module.exports = __webpack_public_path__ + "img/ic_file-out-of-invoices.ff4660f2.svg";